import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { DepartmentTreeNode } from '@/interfaces/model/general/department';
import { flattenTree } from '@/utils/departmentTree';
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DepartmentParentPicker',
  props: {
    value: null,
    tree: null,
    disabledIds: { default: () => new Set<string>() },
    currentId: { default: undefined },
    disabled: { type: Boolean, default: false },
    subtreeHeight: { default: 1 }
  },
  emits: ["input"],
  setup(__props: any) {

const props = __props as { value: string | null, tree: DepartmentTreeNode[], disabledIds: ReadonlySet<string>, currentId: string, disabled: boolean, subtreeHeight: number };

const m = defineMessages({
  noParent: 'なし（最上位の部署）',
});





const MAX_DEPTH = 10;

const options = computed(() =>
  flattenTree(props.tree, new Set()).map((row) => ({
    uuid: row.node.uuid,
    name: row.node.name,
    indent: row.indent,
    hasChildren: row.hasChildren,
    // 配下に置くと 11 階層目が生まれる親は選ばせない (DB 側のトリガでも弾かれる)
    disabled:
      props.disabledIds.has(row.node.uuid) ||
      row.node.depth + props.subtreeHeight > MAX_DEPTH,
  }))
);

return { __sfc: true,m, props, MAX_DEPTH, options }
}

})